import React from 'react';

import { formatDate, formatMoney } from '@betterment/core';
import { Box, Separator, Text, Tooltip } from '@betterment/samba-react';

import type { IraContributionMatchGrants } from './data';

type Props = {
  iraContributionMatchGrants: IraContributionMatchGrants;
};
const IraMatchSummaries: React.FC<Props> = ({ iraContributionMatchGrants }) => {
  return iraContributionMatchGrants?.map(iraContributionMatchGrant => {
    return (
      <Box as="div" key={iraContributionMatchGrant.id}>
        <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} as="span">
          <Box css={{ display: 'flex' }} as="span">
            <Text>Betterment match</Text>
            <Tooltip>
              <Tooltip.Trigger asChild={true}>
                <Tooltip.IconButton name="InfoCircle" aria-label="matched contributions tooltip" />
              </Tooltip.Trigger>
              <Tooltip.Content align="center" side="top">
                {`Your IRA match is based on your net ${
                  iraContributionMatchGrant.grantedEntitiesDescription
                } contributions between ${formatDate(iraContributionMatchGrant.contributionWindow.start)} - ${formatDate(
                  iraContributionMatchGrant.contributionWindow.end
                )}. Your match will be paid on or around ${formatDate(iraContributionMatchGrant.projectedPaymentDate)}.`}
              </Tooltip.Content>
            </Tooltip>
          </Box>
          <Box css={{ display: 'flex', flexDirection: 'column' }} as="span">
            <Text
              css={{
                textAlign: 'right',
              }}
            >
              {formatMoney(iraContributionMatchGrant.earnedMatchAmount)}
            </Text>
          </Box>
        </Box>
        <Separator css={{ my: 'space.200' }} />
      </Box>
    );
  });
};

export default IraMatchSummaries;
